import { render, staticRenderFns } from "./TsAddSkillModal.vue?vue&type=template&id=3da6c587&"
import script from "./TsAddSkillModal.vue?vue&type=script&lang=ts&"
export * from "./TsAddSkillModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports